import React from "react";
import PropTypes from "prop-types";
import BaseButton from "./Button";
import entityMetaStore from "data/meta/entityMetaStore";
import EntityName from "data/util/EntityName";
import invariant from "invariant";

const buildCreateProps = (props, entityKey, options) => {
    if(Array.isArray(options)) {
        // filter createables based off permissions ... allow collapse if filterd list length is equal to unfilterd list length.
        const filteredOptions = options.filter(o => {
            invariant(EntityName.is(o.value), `ActionButton creatable w/ non-EK '${o.value}' value?!`);
            return entityMetaStore.getInfo(o.value).canCreate;
        });
        if(filteredOptions.length > 0) {
            // modify props
            props.collapse = filteredOptions.length === options.length;
            props.options = filteredOptions;
            return true;
        }
        else {
            return false;
        }
    } else if(entityKey) {
        return entityMetaStore.getInfo(entityKey).canCreate;
    }
    throw new Error("ActionButton creatable w/out entityKey?!");
};

const ActionButton = props => {
    const {
        options,
        className,
        focusable = true,
        entityKey,
        disableBehaviour = "hide",
    } = props;
    invariant(!props.implKey, `ActionButton w/ an implKey prop: '${props.implKey}'`);
    const buttonProps = {
        ...props,
        enabled: props.enabled !== undefined ? props.enabled : true
    };

    switch(props.actionType) {
        case "new":
            buttonProps.icon = <i className="glyphicon glyphicon-plus-circle"/>;
            buttonProps.className = "btn btn-default btn-new";
            buttonProps.dropdownCarrot = true;
            if(!buildCreateProps(buttonProps, entityKey, options)) {
                if(disableBehaviour === "hide") {
                    return null;
                }
                else {
                    buttonProps.enabled = false;
                }
            }
            break;
        case "add":
            buttonProps.icon = <i className="glyphicon glyphicon-plus-circle"/>;
            buttonProps.className = "btn-link btn-icon btn-add";
            buttonProps.dropdownCarrot = false;
            if(!buildCreateProps(buttonProps, entityKey, options)) {
                if(disableBehaviour === "hide") {
                    return null;
                }
                else {
                    buttonProps.enabled = false;
                }
            }
            break;
        case "remove":
            buttonProps.icon = <i className="glyphicon glyphicon-remove-circle"/>;
            buttonProps.className = "btn-link btn-icon btn-remove";
            buttonProps.dropdownCarrot = false;
            if(entityKey && !entityMetaStore.getInfo(entityKey).canDelete) {
                if(disableBehaviour === "hide") {
                    return null;
                }
                else {
                    buttonProps.enabled = false;
                }
            }
            break;
        case "view":
            buttonProps.icon = <i className="glyphicon glyphicon-new-window"/>;
            buttonProps.className = "btn-link btn-icon btn-view";
            buttonProps.dropdownCarrot = false;
            break;
        default:
            buttonProps.icon = null;
            buttonProps.dropdownCarrot = true;
            buttonProps.className = "btn btn-default";
    }
    if (focusable) {
        buttonProps.className += " keyboard-focusable";
    }
    if(className) {
        buttonProps.className += " " + className;
    }
    return <BaseButton {...buttonProps} />;
};

ActionButton.propTypes = {
    actionType: PropTypes.string.isRequired,
    focusable: PropTypes.bool,
    disableBehaviour: PropTypes.string,
};

export default ActionButton;



// WEBPACK FOOTER //
// ./app/lib/common/descriptorcontrols/BaseControls/ActionButton.js